import React from 'react';
import { Helmet } from 'react-helmet-async';
import { HOME_DESCRIPTION, HOME_KEYWORDS, HOME_TITLE } from '../../utils/homeSchema';
interface MetaTagsProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  schema?: object | object[];
  language?: string;
  alternateUrls?: Array<{
    lang: string;
    url: string;
  }>;
}
export function MetaTags({
  title = HOME_TITLE,
  description = HOME_DESCRIPTION,
  keywords = HOME_KEYWORDS,
  canonical = 'https://toxicdetector.com/',
  ogTitle,
  ogDescription,
  ogImage = 'https://cdn.magicpatterns.com/uploads/wonwX8zVL7YiLQwtTT8xq8/file_00000000e69c7243bed09cbc104eb039.png',
  ogType = 'website',
  schema,
  language = 'en',
  alternateUrls = []
}: MetaTagsProps) {
  // The homepage graph (Organization + WebSite + WebApplication) is emitted
  // statically from index.html — see utils/homeSchema.ts. Only render a
  // JSON-LD block here when a page supplies its own schema, so we never ship
  // duplicate Organization / WebSite entities.
  const schemaMarkup = schema;
  const defaultAlternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt',
    url: 'https://toxicdetector.com/pt'
  }, {
    lang: 'es',
    url: 'https://toxicdetector.com/es'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id'
  }, {
    lang: 'x-default',
    url: 'https://toxicdetector.com/'
  }];
  const hreflangUrls = alternateUrls.length > 0 ? alternateUrls : defaultAlternateUrls;
  return <Helmet data-id="element-1859" data-mp="1d7ghz1qcus0x">
      <title data-id="element-1860" data-mp="1d76np1ya1ypf">{title}</title>
      <meta name="title" content={title} data-id="element-1861" data-mp="1d4c4fdr02jxl" />
      <meta name="description" content={description} data-id="element-1862" data-mp="188ddpji78pu0" />
      <meta name="keywords" content={keywords} data-id="element-1863" data-mp="185r5dhnhi6aq" />
      <meta name="robots" content="index, follow" data-id="element-1864" data-mp="1mxjidmzt389a" />
      <meta name="language" content={language} data-id="element-1865" data-mp="1myb1hyc7vdio" />
      <meta name="author" content="Chukwuka Paulgreen Agodi" data-id="element-1866" data-mp="1i4qcgvslptvm" />
      <link rel="canonical" href={canonical} data-id="element-1867" data-mp="1vwwihp21ikhc" />

      {hreflangUrls.map(alternate => <link key={alternate.lang} rel="alternate" hrefLang={alternate.lang} href={alternate.url} data-id="element-1868" data-mp="1qy3f4pggw9uw" />)}

      <meta property="og:type" content={ogType} data-id="element-1869" data-mp="25uu74dntajah" />
      <meta property="og:url" content={canonical} data-id="element-1870" data-mp="20wiww1tlu6rq" />
      <meta property="og:title" content={ogTitle || title} data-id="element-1871" data-mp="20wsn9qikafxy" />
      <meta property="og:description" content={ogDescription || description} data-id="element-1872" data-mp="bgtbs2rh0ef5" />
      <meta property="og:image" content={ogImage} data-id="element-1873" data-mp="6i8ae00hfop4" />
      <meta property="og:site_name" content="ToxicDetector" data-id="element-1874" data-mp="6jt2lizbqvjt" />
      <meta property="og:locale" content={language === 'en' ? 'en_US' : language} data-id="element-1875" data-mp="2i51zxfclrw70" />

      <meta name="twitter:card" content="summary_large_image" data-id="element-1876" data-mp="2n4y2da5njfkg" />
      <meta name="twitter:url" content={canonical} data-id="element-1877" data-mp="2n6hjt431nwnt" />
      <meta name="twitter:title" content={ogTitle || title} data-id="element-1878" data-mp="28ez7phdb2m9q" />
      <meta name="twitter:description" content={ogDescription || description} data-id="element-1879" data-mp="2delmvwcp2cl6" />
      <meta name="twitter:image" content={ogImage} data-id="element-1880" data-mp="2dcin4klqp539" />

      {schemaMarkup ? <script type="application/ld+json" data-id="element-1881" data-mp="1zdsov1n6ozdb">
          {JSON.stringify(schemaMarkup)}
        </script> : null}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-1882" data-mp="23eclm43ui0yx" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" data-id="element-1883" data-mp="1pir046wtlzb9" />
      <meta name="theme-color" content="#050505" data-id="element-1884" data-mp="1uh280c3k1zqu" />
    </Helmet>;
}